import React from 'react';

import noDraftIdeasImg from 'img/no_draft_idea.png';

const EmptyState = ({ classes }) => {
  return (
    <div
      className={
        classes.noFoundtemplateAreaWpr
      }
    >
      <img
        src={noDraftIdeasImg}
        className={classes.notFoundImg}
        alt="No templates"
      />

      <h2
        className={classes.notFoundContent}
      >
        Oops!
      </h2>

      <p
        className={
          classes.notFoundContentSmall
        }
      >
        No Scorecard Templates available
      </p>
    </div>
  );
};

export default EmptyState;